export default __webpack_public_path__ + "img/error-500.a46cbc1d.svg";